var _regeneratorRuntime = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events');

var moment = require('moment');

var VideoRoom =
/*#__PURE__*/
function (_EventEmitter) {
  "use strict";

  _inherits(VideoRoom, _EventEmitter);

  function VideoRoom(janus) {
    var _this;

    _classCallCheck(this, VideoRoom);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VideoRoom).call(this));
    _this.janus = janus;
    _this.pluginHandle = null;
    _this.type = null;
    _this.room = null;
    return _this;
  }

  _createClass(VideoRoom, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this2.janus) return reject('no janus');
                  var plugin = {
                    plugin: 'janus.plugin.videoroom',
                    success: function success(pluginHandle) {
                      _this2.pluginHandle = pluginHandle;
                      resolve();
                    },
                    error: function error(_error) {
                      reject(_error);
                    },
                    onmessage: function onmessage(msg, jsep) {
                      if (msg.videoroom) {
                        if (msg.videoroom === 'joined') {
                          _this2.emit('joined', {
                            id: msg.id,
                            private_id: msg.private_id,
                            room: msg.room,
                            publishers: msg.publishers
                          });
                        } else if (msg.videoroom === 'event' && msg.publishers) {
                          _this2.emit('publishers', msg.publishers);
                        } else if (msg.videoroom === 'event' && msg.unpublished) {
                          _this2.emit('leaved', msg.unpublished);
                        } else {
                          console.log(msg);
                        }
                      }

                      if (jsep) {
                        if (_this2.type === 'publisher') {
                          _this2.pluginHandle.handleRemoteJsep({
                            jsep: jsep
                          });
                        } else if (_this2.type === 'subscriber' || _this2.type === 'listener') {
                          _this2.pluginHandle.createAnswer({
                            jsep: jsep,
                            media: {
                              audioSend: false,
                              videoSend: false
                            },
                            success: function success(jsep) {
                              _this2.pluginHandle.send({
                                message: {
                                  request: 'start',
                                  room: _this2.room
                                },
                                jsep: jsep
                              });
                            }
                          });
                        }
                      }

                      _this2.emit('message', {
                        msg: msg,
                        jsep: jsep
                      });
                    },
                    onlocalstream: function onlocalstream(stream) {
                      _this2.emit('localstream', stream);
                    },
                    onremotestream: function onremotestream(stream) {
                      console.log('REMOTE');

                      _this2.emit('remotestream', stream);
                    }
                  };

                  _this2.janus.attach(plugin);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(publishers, pin, bitrate, record, rec_path) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this3.pluginHandle) return reject('plugin not initialized');
                  var message = {
                    request: 'create',
                    permanent: false,
                    publishers: publishers,
                    pin: pin,
                    videocodec: 'h264',
                    bitrate: bitrate,
                    rec_dir: rec_path
                  };

                  if (record) {
                    message.record = true;
                  }

                  _this3.pluginHandle.send({
                    message: message,
                    success: function success(res) {
                      resolve(res.room);
                    },
                    error: function error(_error2) {
                      reject(_error2);
                    }
                  });
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function create(_x, _x2, _x3, _x4, _x5) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "join",
    value: function () {
      var _join = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(type, info) {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this4.pluginHandle) return reject('plugin not initialized');
                  _this4.type = type;
                  _this4.room = info.room;
                  var message = {
                    request: 'join',
                    room: info.room,
                    pin: info.pin
                  };

                  if (type === 'publisher') {
                    message.id = info.id;
                    message.ptype = 'publisher';
                    message.display = info.displayName;
                  } else {
                    message.ptype = type;
                    message.feed = info.publisher;
                    message.private_id = info.subscriber;
                  }

                  _this4.pluginHandle.send({
                    message: message
                  });

                  return resolve();
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function join(_x6, _x7) {
        return _join.apply(this, arguments);
      }

      return join;
    }()
  }, {
    key: "leave",
    value: function () {
      var _leave = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this5.pluginHandle) return reject('plugin not initialized');

                  _this5.pluginHandle.hangup();

                  return resolve();
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function leave() {
        return _leave.apply(this, arguments);
      }

      return leave;
    }()
  }, {
    key: "sendStream",
    value: function () {
      var _sendStream = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(_ref) {
        var _this6 = this;

        var audio, video;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                audio = _ref.audio, video = _ref.video;
                return _context5.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this6.pluginHandle) return reject('plugin not initialized');

                  _this6.pluginHandle.createOffer({
                    media: {
                      audioRecv: false,
                      videoRecv: false,
                      audioSend: audio,
                      videoSend: video
                    },
                    success: function success(jsep) {
                      var message = {
                        request: 'configure',
                        audio: audio,
                        video: video
                      };

                      _this6.pluginHandle.send({
                        message: message,
                        jsep: jsep
                      });

                      resolve();
                    },
                    error: function error(_error3) {
                      reject(_error3);
                    }
                  });
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function sendStream(_x8) {
        return _sendStream.apply(this, arguments);
      }

      return sendStream;
    }()
  }, {
    key: "sendCapture",
    value: function () {
      var _sendCapture = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(_ref2) {
        var _this7 = this;

        var video;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                video = _ref2.video;
                return _context6.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this7.pluginHandle) return reject('plugin not initialized');
                  var media = {
                    videoRecv: false,
                    audioSend: true,
                    video: video
                  };

                  _this7.pluginHandle.createOffer({
                    media: media,
                    success: function success(jsep) {
                      var message = {
                        request: 'configure',
                        audio: true,
                        video: true
                      };

                      _this7.pluginHandle.send({
                        message: message,
                        jsep: jsep
                      });

                      resolve();
                    },
                    error: function error(_error4) {
                      reject(_error4);
                    }
                  });
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function sendCapture(_x9) {
        return _sendCapture.apply(this, arguments);
      }

      return sendCapture;
    }()
  }, {
    key: "handleOffer",
    value: function () {
      var _handleOffer = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(jsep) {
        var _this8 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this8.pluginHandle) return reject('plugin not initialized');

                  _this8.pluginHandle.handleRemoteJsep({
                    jsep: jsep
                  });

                  return resolve();
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function handleOffer(_x10) {
        return _handleOffer.apply(this, arguments);
      }

      return handleOffer;
    }()
  }, {
    key: "startRecording",
    value: function () {
      var _startRecording = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _this9 = this;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this9.pluginHandle) return reject('plugin not initialized');
                  console.log("start recording");

                  _this9.pluginHandle.send({
                    message: {
                      request: 'configure',
                      record: true
                    }
                  });

                  return resolve();
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function startRecording() {
        return _startRecording.apply(this, arguments);
      }

      return startRecording;
    }()
  }]);

  return VideoRoom;
}(EventEmitter);

module.exports = VideoRoom;